/* import __COLOCATED_TEMPLATE__ from './suggestion-box.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { action } from '@ember/object';
import Component from '@glimmer/component';

type SuggestionBoxSignature = {
  Args: {
    icon:
      | 'fin'
      | 'hand'
      | 'rules'
      | 'language'
      | 'new'
      | 'article'
      | 'long-text'
      | 'short-text'
      | 'wave'
      | 'note'
      | 'globe';
    title: string;
    description: string | string[];
    buttonLabel?: string;
    onClick: () => void;
    setHoveredIndex?: (index: number | null) => void;
    hoveredRowIndex?: number | null;
    index?: number;
  };
};

export default class SuggestionBox extends Component<SuggestionBoxSignature> {
  get descriptionLines() {
    return Array.isArray(this.args.description) ? this.args.description : [this.args.description];
  }

  get suggestionBoxIndex() {
    return this.args.index ?? 0;
  }

  get currentHoveredIndex() {
    return this.args.hoveredRowIndex ?? null;
  }

  @action
  setParentHoveredIndex(index: number | null) {
    if (this.args.setHoveredIndex) {
      this.args.setHoveredIndex(index);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::ViewSuggestions::SuggestionBox': typeof SuggestionBox;
  }
}
